export default __webpack_public_path__ + "static/media/StopBottom.b595f776.svg";